<template>

  <div class="grid">
    <loading :active="isLoadingModel" :can-cancel="true" color="#803BB9" :is-full-page="fullPage"></loading>
    <div class="col-12">
      <div class="card">
        <Toast />
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
          <template #item="{ item, props }">
            <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
              <a :href="href" @click="navigate">
                <span :class="[item.icon, 'text-color']" />
                <span class="text-primary font-semibold">{{ item.label }}</span>
              </a>
            </router-link>
          </template>
        </Breadcrumb>
      </div>

      <div class="card">

        <div class="p-fluid formgrid grid" style="margin-top: 1% ; margin-bottom: 1%;">
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" format="number" v-model="search_title">
              </InputText>
              <label for="m_no">Hoarding Name</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" format="number" v-model="search_advertizer">
              </InputText>
              <label for="m_no">Advertizer</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <Dropdown id="User" filter v-model="state_dropdownItem" :options="state_dropdownItems" optionLabel="name"
                :value="state_dropdownItems.value" @change="getDistrictData" display="chip">
              </Dropdown>
              <label for="complaint_status">State</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <Dropdown id="User" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                optionLabel="name" @change="getMuncipalCorporationData" display="chip">
              </Dropdown>
              <label for="complaint_status">District</label>
            </span>
          </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <Dropdown id="User" filter v-model="mcorporation_dropdownItem" :options="mcorporation_dropdownItems"
                optionLabel="name" display="chip">
              </Dropdown>
              <label for="complaint_status">Muncipal Corporation</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="hoarding_type_dropdownItem" :options="hoarding_type_dropdownItems"
                :value="hoarding_type_dropdownItems" optionLabel="name" filter></Dropdown>
              <label for="status">Hoarding Type</label>
            </span>
          </div>
          <!-- <div class="field col-12 md:col-3">
            <span class="p-float-label">
              <Calendar v-model="approved_date_range" selectionMode="range" dateFormat="dd-mm-yy" :showIcon="true" :showTime="false" hourFormat="12" />
              <label>Approved Date Range</label>
            </span>
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-float-label">
              <Calendar v-model="expiry_date_range" selectionMode="range" dateFormat="dd-mm-yy" :showIcon="true" :showTime="false" hourFormat="12" />
              <label>Expiry Date Range</label>
            </span>
          </div> -->

          <!-- <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="search_hoarding" :options="hoarding_dropdownItems"
                :value="hoarding_dropdownItems" optionLabel="name" filter></Dropdown>
              <label for="status">Hoarding</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="search_user" :options="user_dropdownItems" :value="user_dropdownItems"
                optionLabel="name" filter></Dropdown>
              <label for="status">User</label>
            </span>
          </div> -->

          <div class="field col-12 md:col-3">
            <Button icon="pi pi-search" @click="search(1)" v-tooltip.bottom="'Search'" /> &nbsp;
            <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Reset'" class="mr-2" />
            <button v-if="!showFirstFilter" style="color: blue; background: none; border: none" @click="show_filter()">
              more ...
            </button>

          </div>
        </div>

        <DataTable :loading="loading" ref="dt" size="small" :lazy="true" :totalRecords="totalRecords" :paginator="true"
          :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit" :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
          showGridlines :rowHover="true"><template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0"><b>Hoardings List</b></h5>
              <div>
                <Button icon="pi pi-download" @click="exportCSV($event)" v-tooltip.bottom="'Download'"
                  class="mr-2 p-button-help" />
                <br>
                <p>Total : {{ totalRecords }}</p>
              </div>
            </div>
          </template>
          <Column header="Sr. No." style="min-width: 2rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Name" style="min-width: 3rem" :field="columns[2]">
            <template #body="{ data }">
              {{ data.HoardingName }}
            </template>
          </Column>
          <Column header="Type" style="min-width: 3rem" :field="columns[9]">
            <template #body="{ data }">
              {{ data.HoardingType }}
            </template>
          </Column>
          <Column header="Advertizer" style="min-width: 3rem" :field="columns[5]">
            <template #body="{ data }">
              {{ data.Advertizer }}
            </template>
          </Column>
          <!-- <Column header="User" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.UserName }}
            </template>
          </Column> -->
          <Column header="Approved Date" style="min-width: 3rem" :field="columns[11]">
            <template #body="{ data }">
              {{ dateFormatDMY(data.approved_date) }}
            </template>
          </Column>
          <Column header="Expiry Date" style="min-width: 3rem" :field="columns[12]">
            <template #body="{ data }">
              {{ dateFormatDMY(data.expiry_date) }}
            </template>
          </Column>
          <Column header="State" style="min-width: 3rem" :field="columns[18]">
            <template #body="{ data }">
              {{ data.State_name }}
            </template>
          </Column>
          <Column header="district" style="min-width: 3rem" :field="columns[20]">
            <template #body="{ data }">
              {{ data.district_name }}
            </template>
          </Column>
          <Column header="Municipal Corporation" style="min-width: 3rem" :field="columns[22]">
            <template #body="{ data }">
              {{ data.MunicipalCorporation }}
            </template>
          </Column>
          <Column header="Action" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                @click="viewProduct(slotProps.data)" />

            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <!-- View Details Dialog box start -->
    <Sidebar v-model:visible="productViewDialog" :baseZIndex="1000" position="full" @hide="onHide()">

      <h3>Hoarding Details</h3>
      <div class="card">
        <div class="flex flex-column md:flex-row justify-content-center align-items-center">
          <div class="w-full md:w-7">
            <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 600px"
              :center="center" :zoom="7">
              <Marker :options="{ position: hoardinglatlng }"></Marker>
            </GoogleMap>
          </div>
          <!-- <div class="w-full md:w-1">
            <Divider layout="vertical" class="hidden md:flex"><b></b></Divider>
            <Divider layout="horizontal" class="flex md:hidden" align="center"><b></b></Divider>
          </div> -->
          <div class="w-full md:w-5">
            <div class="card" style="width: 100%; height: 600px">
              <table class="media-details-table">
                <tr>
                  <td class="label">Hoarding Name</td>
                  <td class="value">{{ product['HoardingName'] }}</td>
                </tr>
                <tr>
                  <td class="label">Hoarding Type</td>
                  <td class="value">{{ (product['HoardingType']) }}</td>
                </tr>
                <tr>
                  <td class="label">Hoarding Address</td>
                  <td class="value">{{ (product['HoardingAddress']) }}</td>
                </tr>
                <tr>
                  <td class="label">Owner Name</td>
                  <td class="value">{{ (product['OwnerName']) }}</td>
                </tr>
                <tr>
                  <td class="label">Licensor</td>
                  <td class="value">{{ (product['Licensor']) }}</td>
                </tr>
                <tr>
                  <td class="label">Height</td>
                  <td class="value">{{ (product['Height']) }}</td>
                </tr>
                <tr>
                  <td class="label">width</td>
                  <td class="value">{{ (product['width']) }}</td>
                </tr>
                <tr>
                  <td class="label">Advertizer</td>
                  <td class="value">{{ (product['Advertizer']) }}</td>
                </tr>
                <tr>
                  <td class="label">State Name</td>
                  <td class="value">{{ (product['State_name']) }}</td>
                </tr>
                <tr>
                  <td class="label">District Name</td>
                  <td class="value">{{ (product['district_name']) }}</td>
                </tr>
                <tr>
                  <td class="label">Muncipal Corporation</td>
                  <td class="value">{{ (product['MunicipalCorporation']) }}</td>
                </tr>
                <!-- <tr>
                  <td class="label">User Name</td>
                  <td class="value">{{ (product['UserName']) }}</td>
                </tr> -->
                <tr>
                  <td class="label">Approved Date</td>
                  <td class="value">{{ dateFormatDMY(product['approved_date']) }}</td>
                </tr>
                <tr>
                  <td class="label">Expiry Date</td>
                  <td class="value">{{ dateFormatDMY(product['expiry_date']) }}</td>
                </tr>
              </table>
            </div>

            <!-- <div class="card">
              <h6>Document Details</h6>
              <DataTable :value="documentJson">
                <Column header="No">
                  <template #body="{ index }">
                    <span>{{ +index + +1 }}</span>

                  </template>
                </Column>
                <Column field="HoardingName" header="Document">
                  <template #body="{ data }">
                    <span>{{ data.name }}</span>
                  </template>
                </Column>

                <Column field="Documents" header="Docs">
                  <template #body="{ data }">
                    <Button icon="pi pi-eye" @click="viewdoc(data)" v-tooltip.bottom="'View Documents'" />
                  </template>
                </Column>
              </DataTable>
            </div> -->
          </div>
        </div>
        
      </div>
    </Sidebar>
    <!-- View Details Dialog box end -->

    <!-- <Dialog v-model:visible="productdoc" header="Document Details" :style="{ width: '60rem' }" :modal="true"
      @hide="onDialogClose">
      <DataTable :value="documentJson">
        <Column header="No">
          <template #body="{ index }">
            <span>{{ index }}</span>

          </template>
        </Column>
        <Column field="Documents" header="Docs">
          <template #body="{ data }">
            <Button icon="pi pi-eye" @click="viewdoc(data)" v-tooltip.bottom="'View Documents'" />
          </template>
        </Column>
      </DataTable>
    </Dialog> -->
  </div>


</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
import BreadcrumbService from "../service/BreadcrumbService";
import { GoogleMap, Marker } from "vue3-google-map";


export default {
  data() {
    return {

      hoardinglatlng: {},
      showFirstFilter: false,
      productdoc: false,
      documentJson: {},
      center: { lat: 19.0626704, lng: 73.005094 },
      state_dropdownItems: [],
      state_dropdownItem: null,
      district_dropdownItems: [],
      district_dropdownItem: null,
      mcorporation_dropdownItems: [],
      mcorporation_dropdownItem: null,
      hoarding_type_dropdownItems: [],
      hoarding_type_dropdownItem: null,
      imagePath: "",
      dateRange: null,
      // approved_date_range:null,
      // expiry_date_range:null,
      search_title: "",
      search_status: "",
      search_type: "",
      search_advertizer: "",
      status_dropdown: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],

      productViewDialog: false,
      breadcrumbHome: {},
      breadcrumbItems: [],
      BreadcrumbService: null,

      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum("Hoardings", "/hoardinglist");
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;

    this.getStateData();
    this.getDistrictData();
    this.getMuncipalCorporationData();
    this.getHoardingTypeData();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        // await this.get_count();
        // this.get_list();
      }
    },
  },
  methods: {
    show_filter() {
      this.showFirstFilter = true;
    },
    onHide() {
      this.productViewDialog = false;
    },
    viewdoc(data) {
      var path = data.content;
      window.open(path)
    },
    getStateData() {
      this.state_dropdownItems = [];
      var data = {};
      this.loading = true;
      var promise = apis.StateList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].State_name,
              value: response.data.data[x].State_id,
            });
          }
          this.state_dropdownItem = null;
          this.state_dropdownItems = temp_data;
        }
      });
    },
    getDistrictData() {
      this.district_dropdownItems = [];
      var state_id = "";
      if (this.state_dropdownItem) {
        var state_id = this.state_dropdownItem.value;
      }
      var data = {
        state_id: state_id
      };
      this.loading = true;
      var promise = apis.DistrictList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].DistrictID,
            });
          }
          this.district_dropdownItem = null;
          this.district_dropdownItems = temp_data;
        }
      });
    },
    getMuncipalCorporationData() {
      this.mcorporation_dropdownItems = [];
      var district_id = "";
      if (this.district_dropdownItem) {
        var district_id = this.district_dropdownItem.value;
      }
      var data = {
        district_id: district_id
      };
      this.loading = true;

      var promise = apis.MuncipalCorporationList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].MunicipalCorporation,
              value: response.data.data[x].id,
            });
          }
          this.mcorporation_dropdownItem = null;
          this.mcorporation_dropdownItems = temp_data;
        }
      });
    },
    getHoardingTypeData() {
      this.hoarding_type_dropdownItems = [];
      var data = {};
      this.loading = true;
      var promise = apis.HoardingTypeList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].id,
            });
          }
          this.hoarding_type_dropdownItem = null;
          this.hoarding_type_dropdownItems = temp_data;
        }
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_status = "";
        this.search_title = "";
        this.search_type = "";
        this.search_advertizer = "";
        this.state_dropdownItem = null;
        this.district_dropdownItem = null;
        this.mcorporation_dropdownItem = null;
        this.hoarding_type_dropdownItem = null;
        this.showFirstFilter = false;
        // this.approved_date_range =null;
        // this.expiry_date_range =null;
      }

      await this.get_list();
      await this.get_count();
    },

    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return year + "-" + month + "-" + date;
          }
        }
      }
      else {
        return "";
      }
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return date + "-" + month + "-" + year;
          }
        }
      }
      else {
        return "";
      }
    },
    dateFormat(inputDate, info) { },
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var status = '';
      var state = "";
      var district = "";
      var muncipal = "";
      if (this.search_status) {
        status = this.search_status.value;
      }

      if (this.state_dropdownItem) {
        state = this.state_dropdownItem.value;
      }

      if (this.district_dropdownItem) {
        district = this.district_dropdownItem.value;
      }

      if (this.mcorporation_dropdownItem) {
        muncipal = this.mcorporation_dropdownItem.value;
      }
      var data = {
        count: true,
        status: status,
        hoarding_name: this.search_title,
        advertizer: this.search_advertizer,
        hoarding_type: this.search_type,
        state_id: state,
        district_id: district,
        Municipal_CorporationID: muncipal,
        // approved_date_range: this.approved_date_range,
        // expiry_date_range: this.expiry_date_range
      };
      this.loading = true;
      var promise = apis.AdminHoardingMasterList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        this.totalRecords = response.data.data[0].total;
      });
    },
    get_list: function () {
      var status = '';
      var state = "";
      var district = "";
      var muncipal = "";
      var type = "";
      if (this.search_status) {
        status = this.search_status.value;
      }

      if (this.state_dropdownItem) {
        state = this.state_dropdownItem.value;
      }

      if (this.district_dropdownItem) {
        district = this.district_dropdownItem.value;
      }

      if (this.mcorporation_dropdownItem) {
        muncipal = this.mcorporation_dropdownItem.value;
      }

      if (this.hoarding_type_dropdownItem) {
        type = this.hoarding_type_dropdownItem.name;
      }

      var data = {
        Limit: this.limit,
        page_no: this.page_no,
        count: false,
        status: status,
        hoarding_name: this.search_title,
        advertizer: this.search_advertizer,
        hoarding_type: type,
        state_id: state,
        district_id: district,
        Municipal_CorporationID: muncipal,
        // approved_date_range: this.approved_date_range,
        // expiry_date_range: this.expiry_date_range
      };
      this.loading = true;
      var promise = apis.AdminHoardingMasterList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        this.products = response.data.data;
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.id) {
        //
      } else {
        //
      }
      this.productDialog = false;
      this.product = {};
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
    },
    async viewProduct(product) {
      this.product = { ...product };
      this.documentJson = JSON.parse(this.product.document);
      this.documentJson = this.documentJson.document;
      if (this.product['HoardingLocation_Lat'] && this.product['HoardingLocation_Lng']) {
        var lat = parseFloat(this.product['HoardingLocation_Lat']);
        var lng = parseFloat(this.product['HoardingLocation_Lng']);
        this.hoardinglatlng = { lat: lat, lng: lng };
        this.center = { lat: lat, lng: lng };
      }

      this.productViewDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {
    GoogleMap, Marker
  },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";

.media-details-table {
  width: 100%;
  border-collapse: collapse;
}


.media-details-table .label {
  font-size: 13px;
  font-weight: 600;
  padding: 0.5rem 0.1rem 0.5rem 2rem;
  text-align: left;
}

.media-details-table .value {
  font-size: 13px;
  font-weight: 400;
  padding: 0.5rem 0.1rem 0.5rem 3rem;
  text-align: left;
}

.media-details-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>
